<template>
  <div class="page">
    <notifications :messages="notifications" v-if="notifications && notifications.length > 0"/>
    <slot />
  </div>
</template>

<script>
import Notifications from '@/components/Notifications/notifications'
import {notificationMixin} from '@/mixins/notificationMixin'
export default {
  name: 'Page',
  mixins: [notificationMixin],
  components: {
    Notifications
  },
  props: {},
  mounted () {
    // reset notifications when changing routes
    // potentially we could remove this & store all notifications in array to use on a notification page
    this.resetNotifications()
  },
  data: () => ({})
}
</script>

<style lang="scss">
    @import "./page";
</style>



// WEBPACK FOOTER //
// src/components/Page/page.vue